export class AdminFinancialMonthlyPoint {
  label: string

  ordersCount: number

  ordersAmount: number

  manualExternalOrdersCount: number

  manualExternalOrdersAmount: number

  manualExternalOrdersNetAmount: number

  splitAmount: number

  platformFeeAmount: number

  constructor(data: Partial<AdminFinancialMonthlyPoint> = {}) {
    this.label = data.label ?? ""

    this.ordersCount = data.ordersCount ?? 0

    this.ordersAmount = data.ordersAmount ?? 0

    this.manualExternalOrdersCount = data.manualExternalOrdersCount ?? 0

    this.manualExternalOrdersAmount = data.manualExternalOrdersAmount ?? 0

    this.manualExternalOrdersNetAmount = data.manualExternalOrdersNetAmount ?? 0

    this.splitAmount = data.splitAmount ?? 0

    this.platformFeeAmount = data.platformFeeAmount ?? 0
  }
}
